import { z } from "zod";

import { organizationRoleSchema } from "./organizations.js";

// Login H2J (#700): o SenseGuard como cliente OIDC do h2j-auth.

/**
 * `GET /api/v1/sso`: se o botão aparece, se a virada já aconteceu, para onde o "Sair" vai e
 * onde se troca a senha do Login H2J (nulo sem o SSO).
 */
export const ssoStatusSchema = z.object({
  enabled: z.boolean(),
  ssoOnly: z.boolean(),
  endSessionUrl: z.string().url().nullable(),
  passwordUrl: z.string().url().nullable(),
});
export type SsoStatus = z.infer<typeof ssoStatusSchema>;

export const ssoStatusResponseSchema = z.object({ data: ssoStatusSchema });

/** Convite de organização pelo Login H2J: o nome é obrigatório lá. */
export const ssoInviteMemberInputSchema = z.object({
  email: z.string().trim().toLowerCase().email("Invalid email address"),
  name: z.string().trim().min(1, "Name is required").max(120),
  role: organizationRoleSchema,
});
export type SsoInviteMemberInput = z.infer<typeof ssoInviteMemberInputSchema>;

/** `added`: já tinha acesso e entrou direto. `invited`: o Login H2J mandou o e-mail de ativação. */
export const ssoInviteMemberResponseSchema = z.object({
  data: z.object({ status: z.enum(["added", "invited"]) }),
});
export type SsoInviteMemberResponse = z.infer<typeof ssoInviteMemberResponseSchema>;

export const ssoResendInvitationResponseSchema = z.object({
  data: z.object({ status: z.literal("invited") }),
});

export const ssoCancelInvitationResponseSchema = z.object({
  data: z.object({ status: z.literal("cancelled") }),
});
